import { createContext, useContext } from 'react';
var FormikSchemeContext = createContext({});
export var FormikSchemeContextProvider = FormikSchemeContext.Provider;
export function useFormikSchemeContext() {
    return useContext(FormikSchemeContext);
}
